import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {FileV3Api} from "../casa-native-api";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class FileV3RestService implements FileV3Api {
  constructor(private http: HttpClient) {
  }

  private baseUrl(): string {
    return `${environment.eventsApiBase}/v1/files`;
  }

  uploadFile(file: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const req = new HttpRequest('POST', this.baseUrl(), formData, {reportProgress: true});
    return this.http.request(req);
  }
}
